import type { RouteLocationRaw } from 'vue-router'

const PATH_STORAGE_KEY = 'pathAfterSignin'

export function postSigninRoute(): RouteLocationRaw {
  const path = sessionStorage.getItem(PATH_STORAGE_KEY)
  if (path) {
    sessionStorage.removeItem(PATH_STORAGE_KEY)
    return path
  }
  const localPath = localStorage.getItem(PATH_STORAGE_KEY)
  if (localPath) {
    localStorage.removeItem(PATH_STORAGE_KEY)
    return localPath
  }
  return { name: 'home' }
}

export function savePostSigninRoute(path: string) {
  sessionStorage.setItem(PATH_STORAGE_KEY, path)
}

// This is used for the magic link flow, where the user may be signing in from a different tab or window than the one
// they originally initiated the sign in from, so we need to save the path in localStorage instead of sessionStorage.
export function magicLinkPostSignin(): void {
  const path = sessionStorage.getItem(PATH_STORAGE_KEY)
  if (path) {
    localStorage.setItem(PATH_STORAGE_KEY, path)
  }
}
